import {
  ADD_LAYOUT,
  SET_LAYOUTS,
  REMOVE_LAYOUT,
  CHANGE_SELECTED,
  UPDATE_LAYOUTS,
  RENAME_TAB,
  DELETE_PORTLET_FROM_LAYOUT,
  SET_LAYOUT_TYPE,
  SET_TABS,
  SET_TEAM_LAYOUT_EDIT_MODE,
} from "./actionTypes";

export const setLayouts = (layouts) => ({
  type: SET_LAYOUTS,
  layouts: layouts,
});

export const deletePortletFromLayout = (deletePortletInstance) => ({
  type: DELETE_PORTLET_FROM_LAYOUT,
  deletePortletInstance: deletePortletInstance,
});

// export const addPortletToLayout = (addPortlet) => ({
//   type: ADD_PORTLET_TO_LAYOUT,
//   addPortlet: addPortlet
// });

export const updateLayouts = (layouts) => ({
  type: UPDATE_LAYOUTS,
  layouts: layouts,
});
export const setTabs = (tabs) => ({
  type: SET_TABS,
  tabs: tabs,
});

export const addLayout = (layout) => ({
  type: ADD_LAYOUT,
  layout: layout,
});

export const removeLayout = () => ({
  type: REMOVE_LAYOUT,
});

export const changeSelected = (selected) => ({
  type: CHANGE_SELECTED,
  selected: selected,
});

export const renameTab = (title) => ({
  type: RENAME_TAB,
  title: title,
});

export const setLayoutType = (type) => ({
  type: SET_LAYOUT_TYPE,
  layoutType: type,
});

export const setTeamLayoutEditMode = (mode) => ({
  type: SET_TEAM_LAYOUT_EDIT_MODE,
  teamLayoutEditMode: mode,
});
